export default {
    LOAD_CONTENT_CATEGORIES (state, contentCategories) {
        state.items = contentCategories
    },
}